module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedi",
    attrs: {
      "id": "ch00_fm05_deti"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('em', [_vm._v("For Barbara Davis")]), _c('br'), _c('br'), _c('em', [_vm._v("and for Julius and Margery McIntosh")]), _vm._v(","), _c('br'), _c('br'), _c('em', [_vm._v("who have invested so much")]), _c('br'), _c('br'), _c('em', [_vm._v("in art and people")]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-637f634d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm05_deti.vue
// module id = 69
// module chunks = 0